import React from 'react';
import { useTranslation } from 'react-i18next';
import './Header.css';
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  Button,
  CircularProgress,
  useMediaQuery,
  IconButton,
  Menu,
  MenuItem,
  useTheme
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import LanguageDropdown from './LanguageDropdown';
import { useAuth } from '../contexts/AuthContext';
import { useUser } from '../contexts/UserContext';
import Waffle from './Waffle';
import UserMenu from './UserMenu';
import ImportedWaffle from './ImportedWaffle';
import { getBaseUrl } from '../config/waffle.config';

const Header: React.FC = () => {
  const { t } = useTranslation();
  const { isAuthenticated, logout } = useAuth();
  const { profileLoading, getDisplayName } = useUser();
  const theme = useTheme();
  const baseUrl = getBaseUrl();
  
  const handleLogout = async () => {
    try {
      console.log('Initiating logout...');
      await logout();
    } catch (error) {
      console.error('Logout failed:', error);
      // Force clear storage and redirect as fallback
      localStorage.clear();
      sessionStorage.clear();
      window.location.href = '/';
    }
  };

  return (
    <AppBar
      position="static"
      elevation={0}
      sx={{
        backgroundColor: 'white',
        color: 'text.primary'
      }}
    >
      <Toolbar sx={{ flexWrap: 'wrap' }} className="header-toolbar">
        {/* Logo group - keeps waffle, logo and app name together */}
        <Box className="logo-group">
          {/* Waffle component */}
          <Box sx={{ display: 'flex', alignItems: 'center', mr: 1 }}>
            <ImportedWaffle />
          </Box>
          
          {/* 3E Logo */}
          <Box sx={{ display: 'flex', alignItems: 'center', mr: 2 }}>
              <img
                src={`${baseUrl}/Content/images/3E%20Logo_Full%20Color.svg`}
                alt="3E Logo"
                className="app-logo"
                height={35}
              />
          </Box>
          
          {/* Application Title */}
          <Typography
            align='left'
            variant="h6"
            component="div"
            noWrap
            sx={{
              fontSize: { xs: '18px', sm: '24px' }
            }}
          >
            {t('header.appTitle')}
          </Typography>
        </Box>
        
        {/* Spacer */}
        <Box sx={{ flexGrow: 1 }} />
        
        {/* User controls */}
        {
          <>
            {/* User info */}
            {isAuthenticated && (
              <UserMenu onLogout={handleLogout} showHelp={true} />
            )}
            
            {/* Language dropdown */}
            <Box sx={{ mr: 2 }}>
              <LanguageDropdown />
            </Box>
            
          </>
          }
      </Toolbar>
    </AppBar>
  );
};

export default Header;